export const PIPELINE_SETTINGS_DATA_IDS_CONTRACT = {
  base: 'pipeline-settings',
  form: 'pipeline-settings-form',
  formContent: 'pipeline-settings-form-content',
  errorBanner: 'pipeline-settings-error',
  editing: 'pipeline-settings-editing',
  submit: 'pipeline-settings-submit',
  save: 'pipeline-settings-save',
  setupGuideDocs: 'setup-guide-docs'
};
